//The state for the IPC1752a export view

export interface Ipc1752AExportState {
    inventoryId: string | null, //InventoryID of the current viewed inventory
    ipc1752aData: Ipc1752AXmlData, //Object representing the format specified in the IPC1752A Data model
    selectedProduct: Product | null, //Selected Product of which the homogenous materials are displayed
    exportClassA: boolean, //Export Query List and Exemption List in the XML
    exportClassC: boolean, //Export Substance Categories in the XML
    exportClassD: boolean, //Export Homogenous Materials in the XML
    dataLoaded: boolean,
    showAlert: boolean,
    hightlightMissingRequiredFields: boolean;
}

export interface BusinessInfo {
    mode: string;
    responseDate: string;
    companyName: string;
    authorizedRepresentiative: string;
    representativeEmail: string;
    representativePhone: string;
    requestDate: string;
    requestCompany: string;
    supplierContact: Contact;
    requestorContact: Contact;
}

export interface Contact {
    contactName: string;
    contactEmail: string;
    contactPhone: string;
}
export interface Ipc1752AXmlData {
    version: string;
    businessInfo: BusinessInfo;
    products: Product[];
}

export function initialIpc1752aData(): Ipc1752AXmlData {
    return {
        version: "2.0",
        businessInfo: {
            mode: "Distribute",
            responseDate: "",
            companyName: "",
            authorizedRepresentiative: "",
            representativeEmail: "",
            representativePhone: "",
            requestDate: "",
            requestCompany: "",
            supplierContact: {
                contactEmail: "",
                contactName: "",
                contactPhone: ""
            },
            requestorContact: {
                contactEmail: "",
                contactName: "",
                contactPhone: ""
            },
        },
        products: []
    }
}

export interface Product {
    comment: string;
    numberOfInstances: number;
    productId: ProductId;
    materialInfo: MaterialInfo;
    subproduct: Product[];
}

export interface ProductId {
    itemName: string;
    itemNumber: string;
    manufacturingSite: string;
    effectiveDate: string;
    version: string;
    uom: string;
    uomValue: number;
}

export interface MaterialInfo {
    queryList: QueryList[];
    exemptionList: ExemptionList[];
    homogenousMaterialsList: HomogenousMaterial[];
    substanceCategoryLists: SubstanceCategoryList[];
}

export interface ExemptionList {
    exemptions: Exemption[];
    identity: string;
    authority: string;
}

export interface Exemption {
    description: string;
    identity: string;
}

export interface QueryList {
    queries: Query[];
    identity: string;
    authority: string;
    revision: string;
}

export interface Query {
    statement: string;
    response: boolean | null;
    identity: string;
    authority: string;
    revision: string;
    computedResponse: boolean;
}

export interface HomogenousMaterial {
    name: string;
    comment: string;
    materialGroupName: string;
    uom: string;
    uomValue: number;
    substanceCategoryLists: SubstanceCategoryList[];
}

export interface SubstanceCategoryList {
    identity: string;
    authority: string;
    revision: string;
    substanceCategories: SubstanceCategory[];
}

export interface SubstanceCategory {
    name: string;
    comment: string;
    identity: string;
    uom: string;
    uomValue: number;
    substance: Substance;
    overThreshold: boolean | null;
    thresholdStatement: string;
    rohsExemption: ExemptionList | null;
    reportableApplication: string;
    concentration: string;
}

export interface Substance {
    casNumber: string;
    substanceName: string;
    uom: string;
    uomValue: number;
    rohsExemption: ExemptionList;
}